const documentUpload = () => {
  const fileInput = document.querySelector(".custom-file-input");
  if (fileInput) {
    fileInput.addEventListener("change", (event) => {
      const uploadedFile = event.target.files[0];
      const confirmationTarget = document.querySelector(".custom-file-label");
      confirmationTarget.style.backgroundColor = "#2B8E56";
      confirmationTarget.innerText = uploadedFile.name;
      // confirmationTarget.innerText = `Document ajouté ! (${uploadedFile.name})`;
      confirmationTarget.style.color = "white";
      event.target.style.boxShadow = "none";
    });
  }
};

export default documentUpload;
